import React, { useState } from "react";
import { useReportData } from "../hooks/useReportData";
import { ReportFilterBar } from "../components/ReportFilterBar";
import { ReportKpiCards } from "../components/ReportKpiCards";
import { TransactionGrid } from "../components/TransactionGrid";
import { useSession } from "../hooks/useSession";
import { Alert, Button, Spinner } from "react-bootstrap";

export const ReportsDashboard = () => {
  const { userid, role } = useSession(); 
  const currentUser = { id: userid, role: role }; 
  
  const { filters, updateFilters, loading, error, reportData } = useReportData(currentUser);
  const [selectedReceipt, setSelectedReceipt] = useState(null);

  const handleExportCSV = () => {
    if (!reportData?.transactions?.length) return;
    const headers = Object.keys(reportData.transactions[0]).join(",");
    const rows = reportData.transactions
      .map((row) => Object.values(row).map((v) => `"${v}"`).join(","))
      .join("\n");
    const blob = new Blob([`${headers}\n${rows}`], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", `report_${filters.startDate}_to_${filters.endDate}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <main>
      <div className="container-fluid">
        {/* Modern Custom Header */}
        <div className="row m-1 mb-4">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <div>
              <h4 className="main-title fw-bold" style={{ color: "#1a1a1a", fontSize: "1.8rem", marginBottom: "4px" }}>
                Financial & Transaction Reports
              </h4>
              <div className="d-flex align-items-center gap-2 mb-0" style={{ fontSize: "13.5px", fontWeight: "500" }}>
                <a href="#" className="text-decoration-none" style={{ color: "#7e57c2", display: "flex", alignItems: "center" }}>
                  <i className="ph-duotone ph-chart-line-up f-s-16"></i> <span className="ms-1">Reports</span>
                </a>
                <span style={{ color: "#a0a5b1" }}>/</span>
                <span className="text-muted">
                  Active Role: <strong className="text-primary">{reportData.role || currentUser.role || "Loading..."}</strong>
                </span>
                {loading && (
                    <Spinner animation="border" size="sm" className="text-primary ms-2" />
                )}
              </div>
            </div>
            <div>
              {/* Optional header right component if needed */}
            </div>
          </div>
        </div>

        <div className="row m-1">
          <div className="col-12">
            {/* Filter Bar */}
            <ReportFilterBar
              filters={filters}
              onFilterChange={updateFilters}
              onExport={handleExportCSV}
              loading={loading}
            />

            {/* Error Banner */}
            {error && (
              <div 
                className="d-flex align-items-center p-3 mb-4 rounded-3 text-white shadow-sm" 
                style={{ backgroundColor: "#7e57c2" }}
              >
                <i className="ph-duotone ph-warning-circle fs-5 me-2"></i> 
                <span className="fw-medium">{error}</span>
              </div>
            )}

            {/* KPI Cards */}
            <ReportKpiCards totals={reportData.grandTotals} role={reportData.role} />

            {/* Grid */}
            <TransactionGrid
              transactions={reportData.transactions || []}
              role={reportData.role}
              onSelectReceipt={(tx) => setSelectedReceipt(tx)}
            />

            {/* Pagination Footer */}
            {reportData.pagination && reportData.pagination.total_pages > 1 && (
              <div className="d-flex align-items-center justify-content-between bg-white px-4 py-3 rounded-3 shadow-sm mt-4 border-0">
                <span className="text-muted small fw-medium">
                  Showing Page {reportData.pagination.page} of {reportData.pagination.total_pages} ({reportData.pagination.total_rows} records)
                </span>
                <div className="d-flex gap-2">
                  <Button
                    variant="light"
                    size="sm"
                    className="fw-semibold px-3 border"
                    disabled={reportData.pagination.page <= 1 || loading}
                    onClick={() => updateFilters({ page: filters.page - 1 })}
                  >
                    Previous
                  </Button>
                  <Button
                    variant="light"
                    size="sm"
                    className="fw-semibold px-3 border"
                    disabled={reportData.pagination.page >= reportData.pagination.total_pages || loading}
                    onClick={() => updateFilters({ page: filters.page + 1 })}
                  >
                    Next
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
};
export default ReportsDashboard;
